/**
 * @ngdoc directive
 * @name internshipspanel
 *
 * @description
 * Internships panel
 */
module.directive('internshipspanel', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            content: '=',
            upsell: '@?'
        },
        controller: function ($scope, drupal, $filter, $rootScope, lodash) {
            $scope.isUpsell = $scope.upsell === 'true';
            $scope.loading = true;

            $scope.config = $rootScope.config.site;


            drupal.getThemes().then(function (themes) {
                $scope.themes = themes;
                return drupal.getAllSimpleInternships();
            }).then(function(internships) {
                $scope.content.field_promo = {};
                $scope.content.field_trainings = [{}, {}, {}, {}, {}];

                var lastMinutes = [];

                function storeCheaperPrice(actual, current) {
                    if (lodash.isEmpty(actual) || actual.price > current.price ) {
                        angular.copy(current, actual);
                    }
                }

                (internships || []).forEach(function(internship) {
                    if (internship.product.sfid === $scope.config.bloc_offres.offre_1) {
                        storeCheaperPrice($scope.content.field_trainings[0], internship);
                    }
                    else if (internship.product.sfid === $scope.config.bloc_offres.offre_2) {
                        storeCheaperPrice($scope.content.field_trainings[1], internship);
                    }
                    else if (internship.product.sfid === $scope.config.bloc_offres.offre_3) {
                        storeCheaperPrice($scope.content.field_trainings[2], internship);
                    }
                    else if (internship.product.sfid === $scope.config.bloc_offres.offre_4) {
                        storeCheaperPrice($scope.content.field_trainings[3], internship);
                    }
                    else if (internship.product.sfid === $scope.config.bloc_offres.offre_5) {
                        storeCheaperPrice($scope.content.field_trainings[4], internship);
                    } else if (internship.lastMinute === true) {
                        internship = angular.copy(internship)
                        if (internship.product && internship.product.page && internship.product.page.field_theme) {
                            const theme = lodash.find($scope.themes, { nid: internship.product.page.field_theme });
                            if (theme) {
                                internship.product.page.field_theme = theme;
                            }
                        }
                        lastMinutes.push(internship);
                    }
                    if (internship.sfid === $scope.config.bloc_offres.offre_moment && !$scope.content.field_promo.sfid) {
                        if (internship.lastMinute !== true && internship.product && internship.product.page && internship.product.page.field_theme) {
                            const theme = lodash.find($scope.themes, { nid: internship.product.page.field_theme });
                            if (theme) {
                                internship.product.page.field_theme = theme;
                            }
                        }
                        storeCheaperPrice($scope.content.field_promo, internship);
                    }
                });

                for(var i = 0; i < $scope.content.field_trainings.length; i++) {
                    if ($scope.content.field_trainings[i] && $scope.content.field_trainings[i].product && $scope.content.field_trainings[i].product.page && $scope.content.field_trainings[i].product.page.field_theme) {
                        const theme = lodash.find($scope.themes, { nid: $scope.content.field_trainings[i].product.page.field_theme });
                        if (theme) {
                            $scope.content.field_trainings[i].product.page.field_theme = theme;
                        }
                    }
                }

                if (lastMinutes.length > 0) {
                    angular.copy(lastMinutes[Math.floor(Math.random() * lastMinutes.length)], $scope.content.field_promo);
                }
            }).finally(function () {
                $scope.loading = false;
            });
        },
        templateUrl: 'src/components/internshipspanel/internshipspanel.html'
    };
});

module.directive('internshipspaneloffer', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '=',
            priceless: '@?',
            enabledescription: '@?'
        },
        controller: function ($scope, $window, tools, lodash) {
            $scope.tools = tools;

            // Set to first element in slideshow
            $scope.current = 0;
            var initSlider = function() {
                $scope.itemsPerSlide = ($window.innerWidth < 480) ? 1 : 3;
                $scope.numberItems = Math.max(1, Math.round($scope.content.field_internships.length / $scope.itemsPerSlide));
            };
            initSlider();

            angular.element($window).on('resize', function() {
                initSlider();
                $scope.$apply();
            });

            $scope.$watch('content', initSlider, true);

            $scope.setSlide = function(slideId) {
                $scope.current = slideId;
            };
            $scope.prev = function() {
                $scope.current = Math.max(0, $scope.current - 1);
            };
            $scope.next = function() {
                $scope.current = Math.min($scope.numberItems - 1, $scope.current + 1);
            };

            $scope.$on('destroy', function() {
                $window.onresize = null;
            });
        },
        templateUrl: 'src/components/internshipspanel/internshipspaneloffer.html'
    };
});

module.directive('internshipspanelitem', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            content: '=',
            ispromo: '@?',
            hasdescription: '@?',
            ispriceless: '@?',
            offer: '@?'
        },
        controller: function ($scope, lodash) {
            $scope.$watch("content.product", function (product) {
                if (product && product.page) {
                    if (product.page.field_visuals && product.page.field_visuals.length) {
                        $scope.content.product.page.main_visual = lodash.sample(product.page.field_visuals);
                    }
                    else if (product.page.field_theme && product.page.field_theme.field_visuals && product.page.field_theme.field_visuals.length) {
                        $scope.content.product.page.main_visual = lodash.sample(product.page.field_theme.field_visuals);
                    }
                }
            });
        },
        templateUrl: 'src/components/internshipspanel/internshipspanelitem.html'
    };
});

module.directive('internshipspanellargeitem', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            content: '=',
            ispromo: '@?',
            hasdescription: '@?',
            ispriceless: '@?',
            offer: '@?'
        },
        controller: function ($scope, lodash) {
            $scope.$watch("content.product", function (product) {
                if (product && product.page) {
                    if (product.page.field_visuals && product.page.field_visuals.length) {
                        $scope.content.product.page.main_visual = lodash.sample(product.page.field_visuals);
                    }
                    else if (product.page.field_theme && product.page.field_theme.field_visuals && product.page.field_theme.field_visuals.length) {
                        $scope.content.product.page.main_visual = lodash.sample(product.page.field_theme.field_visuals);
                    }
                }
            });
        },
        templateUrl: 'src/components/internshipspanel/internshipspanellargeitem.html'
    };
});
